import React from "react"

export default function Project (props){

return(
        <div className="main projects">
                <div className="project-element">
                    <div className="project-content"><span class="material-symbols-outlined bullet3">crop_portrait</span>
                        <h5 className="project-name">{props.title}</h5>
                        <a href= {props.projectLink} target="_blank"><button className="buttons btn1 btn-float">check it out</button></a>
                        <h4 className="project-h4">Description</h4>
                        <p className="project-description">{props.description}</p>
                        <h4 className="project-h4">technologies</h4>
                        <p className="project-technology">{props.technologies}</p>
                    </div>
                    <a href= {props.projectLink} target="_blank"><img src={props.imageUrl} alt="project 1" className="project-image"></img></a>
                </div>
        </div>
)
}